module.exports = __webpack_public_path__ + "img/0-33.0534c8da.jpg";